import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Box, Grid, Select, Typography } from "@mui/material";
import RefreshIcon from "../../../Assets/Table/RefreshIcon";
import { FilterIcon } from "../../../Assets/Table/FilterIcon";
import { SortDIcons } from "../../../Assets/Table/SortDIcons";
import { HospitalIcon } from "../../../Assets/Table/HospitalIcon";
import { MedicalCareIcon } from "../../../Assets/Table/MedicalCareIcon";
import { DeclineIcon } from "../../../Assets/Table/DeclineIcon";
import { ExclamationIcon } from "../../../Assets/Table/ExclamationIcon";
import { Share } from "../../../Assets/Icons/Share";
import { Thumbtack } from "../../../Assets/Icons/Thumbtack";
import { Delete } from "../../../Assets/Icons/Delete";
import { Time } from "../../../Assets/Icons/Time";
import { Mail } from "../../../Assets/Icons/Mail";
import { ChatBlack } from "../../../Assets/Icons/ChatBlack";
import useMySpace from "./useMySpace.logic";
import moment from "moment";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import InfiniteScroll from "react-infinite-scroll-component";

const tableHead = {
  fontSize: "14px",
  color: "#4C5A6A",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  gap: 1,
};

const useStyles = makeStyles({
  customDivider: {
    backgroundColor: "#E7EEF8",
  },
});

const MySpace = () => {
  const state = useMySpace();
  const [hover, setHover] = useState(0);

  const type = [
    {
      name: "Center",
      value: "CENTER",
    },
    {
      name: "Hospital",
      value: "HOSPITAL",
    },
    {
      name: "Doctor",
      value: "DOCTOR",
    },
    {
      name: "Professional",
      value: 'PROFESSIONAL'
    }
  ];

  const departments = [
    {
      name: "Finance",
      value: "FINANCE",
    },
    {
      name: "Operations",
      value: "OPERATIONS",
    },
    {
      name: "Insurance",
      value: "INSURANCE",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#F9FBFC",
        width: "77%",
        height: "94vh",
        margin: "5px  25px",
        borderRadius: "20px",
      }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "40px 40px  10px 30px",
        }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "22px",
          }}>
          <Typography sx={{ fontWeight: 600, fontSize: "22px" }}>
            My Space
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              width: "30px",
              height: "30px",
              borderRadius: "8px",
              bgcolor: "#ECF1F5",
            }}>
            <RefreshIcon />
          </Box>
        </Box>

        <Grid mb={1} item lg={1}>
          <DropDown
            placeHolder="Type"
            viewHeight={"40px"}
            borderRadius={"8px"}
            borderColor={"red"}
            border={"1px solid #DFE5EE"}
            bgColor="#FFFFFF"
            handleSelected={(e, value, reason) => {
              if (reason === "clear") {
                state.setAllTasks(null);
                state.setDataTypes(null);
                return;
              }
              state.setAllTasks(null);
              state.setDataTypes([value?.value]);
            }}
            data={type}
          />
        </Grid>
        <Grid mb={1} item lg={1}>
          <DropDown
            placeHolder="Department"
            viewHeight={"40px"}
            borderRadius={"8px"}
            borderColor={"red"}
            border={"1px solid #DFE5EE"}
            bgColor="#FFFFFF"
            handleSelected={(e, value) => {
              state.setFilter((s) => ({ ...s, department: value?.value }));
            }}
            data={departments}
          />
        </Grid>
        <Grid mb={1} item lg={1}>
          {/* <DropDown
            placeHolder="Platform"
            viewHeight={"40px"}
            borderRadius={"8px"}
            border={"1px solid #DFE5EE"}
            bgColor="#FFFFFF"
            handleSelected={(e, value) => {
              state.setFilter((s) => ({ ...s, platformId: value?.id }));
            }}
            data={state.platform}
          /> */}
        </Grid>
        <Grid mb={1} item>
          <SearchBar
            width={230}
            placeHolder={"Search Name"}
            onChagevalue={(e) =>
              state.setFilter((s) => ({ ...s, keyword: e.target.value }))
            }
          />
        </Grid>
      </Box>
      <Box
        sx={{
          padding: "10px 20px",
        }}>
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#F9FBFC",
            maxHeight: "82vh",
            boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px;",
          }}>
          <InfiniteScroll
            dataLength={state.allTasks?.length || 0}
            next={state.fetchAllTasks}
            hasMore={state.count > state.allTasks?.length}
            height={"80vh"}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead
                sx={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#F9FBFC",
                }}>
                <TableRow>
                  <TableCell align="left">
                    <Typography sx={tableHead}>
                      Time
                      <Box sx={{ cursor: "pointer" }}>
                        <SortDIcons />
                      </Box>
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    <Typography sx={tableHead}>
                      Type
                      <Box
                        sx={{ cursor: "pointer", transform: "rotate(180deg)" }}>
                        <SortDIcons />
                      </Box>
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    <Typography sx={tableHead}>
                      Department
                      <Box
                        sx={{ cursor: "pointer", transform: "rotate(180deg)" }}>
                        <SortDIcons />
                      </Box>
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    <Typography sx={tableHead}>
                      Name
                      <Box sx={{ cursor: "pointer" }}>
                        <SortDIcons />
                      </Box>
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {" "}
                    <Typography paddingLeft={10} sx={tableHead}>
                      Status
                      <Box sx={{ cursor: "pointer" }}>
                        <SortDIcons />
                      </Box>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.allTasks?.map((row) => {
                  return (
                    <TableRow
                      component={"div"}
                      align="left"
                      key={row.name}
                      onClick={() =>
                        state?.handleOpenPopUp(
                          row?.typeId,
                          row?.dataType,
                          row?.status,
                          row?.id,
                          row
                        )
                      }
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setHover(row.id)}
                      onMouseLeave={() => setHover(0)}>
                      <TableCell component="th" scope="row">
                        <Box
                          sx={{
                            display: "flex",
                            alignContent: "center",
                            gap: 1,
                          }}>
                          {row.id === hover ? (
                            <Box mt={1}>
                              <input type="checkbox" />
                            </Box>
                          ) : (
                            <></>
                          )}

                          <Box>
                            {/* <Typography sx={tableHead}>{row.date}</Typography> */}
                            <Typography
                              sx={{
                                fontSize: "13px",
                                color: "#4C5A6A",
                              }}>
                              {moment(row?.date).format("MMM DD")}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "13px",
                                color: "#4C5A6A",
                              }}>
                              {moment(row?.date).format("hh:mm A")}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              bgcolor: "#788597",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "50px",
                              height: "22px",
                              borderRadius: "20px",
                              color: "white",
                              fontSize: "11px",
                              marginTop: 1,
                            }}>
                            New
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontSize: "14px",
                          color: "#4C5A6A",
                        }}>
                        {row?.dataType}
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontSize: "14px",
                          color: "#4C5A6A",
                        }}>
                        {row?.department}
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          sx={{
                            fontSize: "15px",
                            color: "#2E2E2E",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}>
                          {/* <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {row.section === "hospital" ? (
                          <HospitalIcon />
                        ) : (
                          <MedicalCareIcon />
                        )}
                      </Box> */}
                          {row.name}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          <Box
                            component={"span"}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              border: `solid 1px ${row.status === "Rejected"
                                ? "#ee404c"
                                : "#f89d1c"
                                }`,
                              borderRadius: "10px",
                              height: "34px",
                              width: "130px",
                              backgroundColor:
                                row?.status !== "Rejected"
                                  ? "#fef7ef"
                                  : "#feefef",
                              gap: 1,
                              color: "#2E2E2E",
                              fontSize: "14px",
                              transition: "transform 100ms",
                              transform:
                                hover === row.id
                                  ? "translateX(-15px)"
                                  : "translateX(0)",
                            }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}>
                              {row.status === "Rejected" ? (
                                <DeclineIcon />
                              ) : (
                                <ExclamationIcon />
                              )}
                            </Box>
                            {row.status}
                          </Box>
                          {row.id === hover ? (
                            <Box
                              component={"div"}
                              display={"flex"}
                              alignItems={"center"}
                              gap={3}
                              bgcolor={"white"}
                              px={3}
                              py={1}
                              borderRadius={"8px"}>
                              <Thumbtack />

                              <Time />

                              <Mail />

                              <ChatBlack />
                            </Box>
                          ) : (
                            <></>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </InfiniteScroll>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default MySpace;
